<template>
  <div>
    <div
      class="preload"
      :style="[loading ? { display: 'flex' } : { display: 'none' }]"
    >
      <div class="loader" />
    </div>
    <div
      data-collapse="medium"
      data-animation="default"
      data-duration="400"
      data-w-id="b2ac5f58-917a-c8c4-4b27-3b66481451a6"
      role="banner"
      class="nav-bar navbar w-nav"
    >
      <div class="wrapper nav-bar-wrapper">
        <div class="brand w-nav-brand">
          <div class="logo-text">Jules</div>
          <img
            v-if="company"
            :src="'/media/logos/' + company.logo"
            alt=""
            class="logo main-logo checkout"
          />
        </div>
        <div class="navigation">
          <div class="nav-right">
            <div class="w-layout-grid nav-buttons">
              <a
                id="w-node-3b66481451af-481451a6"
                href="#"
                class="button ghost nav-icon w-inline-block w-clearfix"
                @focusout="hideCart"
                @click="showCart"
              >
                <img
                  v-if="patients.length > 0"
                  src="signUp/images/shopping-cart-full.svg"
                  alt=""
                  class="button-icon shopping-cart" />
                <img
                  v-else
                  src="signUp/images/shopping-cart-empty.svg"
                  alt=""
                  class="button-icon shopping-cart"
              /></a>
            </div>
          </div>
          <div class="nav-search">
            <form action="/search" class="nav-search-form w-form">
              <img
                src="signUp/images/search-dark.svg"
                alt=""
                class="big-form-icon"
              /><input
                id="search"
                type="search"
                class="form-big-input w-input"
                autofocus="true"
                maxlength="256"
                name="query"
                placeholder="What are you looking for?"
                required=""
              /><input
                type="submit"
                value="Search"
                class="big-form-button w-button"
              />
            </form>
            <div
              data-w-id="b2ac5f58-917a-c8c4-4b27-3b66481451b6"
              class="popup-bg-overlay"
            >
              <div class="modal-close-button" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-2">
      <div class="wrapper shop-cart-container w-container">
        <div
          id="w-node-9d8742d60dce-9ede2a5a"
          class="shopping-list-container"
          :style="{
            opacity: isCartOpen ? 1 : 0,
            display: isCartOpen ? 'block' : 'none',
          }"
        >
          <h3 class="volk green">Shopping Cart</h3>
          <!-- shopping cart -->

          <div class="full-width w-form">
            <form
              id="Contact-Form-1"
              name="email-form"
              data-name="Email Form"
              class="receipt-blue-box"
            >
              <div v-for="patient in patients" :key="patient.id">
                <label
                  v-if="patient.plan"
                  id="w-node-341224005ca9-59de2a59"
                  for="name"
                  class="text-grey cart-text"
                  >{{ patient.first_name }} {{ patient.last_name }}</label
                >
                <div
                  v-if="patient.plan"
                  id="w-node-202f93e4267a-59de2a59"
                  class="pull-left"
                >
                  <label class="left-not-bold">{{
                    patient.plan.display_name
                  }}</label>
                  <label
                    v-for="addon in patient.addons"
                    :key="addon.ada_code"
                    class="left-not-bold"
                    >{{ addon.display_name }}</label
                  >
                  <label
                    v-for="discount in patient.discounts"
                    :key="discount.code"
                    class="left-not-bold"
                    >{{ discount.name }}</label
                  >
                </div>
                <div v-if="patient.plan" id="w-node-202f93e4267e-59de2a59">
                  <label
                    class="bold-right"
                    v-if="
                      patient.plan.interval === 'year' &&
                      patient.plan.annual_base_price
                    "
                    >${{ patient.plan.annual_base_price | toMonetary }}</label
                  >
                  <label
                    class="bold-right"
                    v-else-if="
                      patient.plan.interval === 'semi-annually' &&
                      patient.plan.semiannual_base_price
                    "
                    >${{
                      patient.plan.semiannual_base_price | toMonetary
                    }}</label
                  >
                  <label class="bold-right" v-else
                    >${{
                      (patient.plan.base_price * intervalMultiplier)
                        | toMonetary
                    }}</label
                  >
                  <label
                    v-for="addon in patient.addons"
                    :key="addon.ada_code"
                    class="bold-right"
                    v-if="patient.plan.interval === 'year'"
                  >
                    <span
                      v-if="
                        patient.plan.interval === 'year' &&
                        addon.annual_base_price
                      "
                    >
                      ${{ addon.annual_base_price | toMonetary }}
                    </span>
                    <span
                      v-else-if="
                        patient.plan.interval === 'semi-annually' &&
                        addon.semiannual_base_price
                      "
                    >
                      ${{ addon.semiannual_base_price | toMonetary }}
                    </span>
                    <span v-else>
                      ${{
                        (addon.base_price * intervalMultiplier) | toMonetary
                      }}
                    </span>
                  </label>
                  <label
                    v-for="addon in patient.addons"
                    :key="addon.ada_code"
                    class="bold-right"
                    v-else-if="patient.plan.interval === 'semi-annually'"
                    >${{ (addon.base_price * 6) | toMonetary }}</label
                  >
                  <label
                    v-for="addon in patient.addons"
                    :key="addon.ada_code"
                    class="bold-right"
                    v-else
                    >${{ addon.base_price | toMonetary }}</label
                  >
                  <label
                    v-for="discount in patient.discounts"
                    :key="discount.consumer_code"
                    class="bold-right"
                    >-${{ discount.appropriation_amount * intervalMultiplier | toMonetary }}</label
                  >
                </div>
              </div>

              <div v-if="patients.length > 0">
                <div
                  id="w-node-c9ac6dc05b64-59de2a59"
                  class="div-block-5 my-20"
                />

                <div id="w-node-d5731c70613e-59de2a59">
                  <label for="email" class="left-not-bold pull-left"
                    >Enrollment Fee X{{ patients.length }}</label
                  >
                </div>

                <div>
                  <label
                    for="email"
                    class="bold-right"
                    v-if="intervalMultiplier === 1 || !waiveEnrollmentFee"
                    >${{ fees | toMonetary }}</label
                  >
                  <label
                    for="email"
                    class="bold-right"
                    style="font-size: 11px; color: green"
                    v-else-if="intervalMultiplier === 6 && waiveEnrollmentFee"
                    >Waived for Semi-Annual Payments</label
                  >
                  <label
                    for="email"
                    class="bold-right"
                    style="font-size: 11px; color: green"
                    v-else-if="intervalMultiplier === 12 && waiveEnrollmentFee"
                    >Waived for Annual Payments</label
                  >
                </div>

                <div
                  id="w-node-202f93e42682-59de2a59"
                  class="dark-line my-20"
                />

                <div id="w-node-d1926997240e-59de2a59">
                  <label for="email" class="left-not-bold pull-left"
                    >Today&#x27;s Total</label
                  >
                </div>

                <div>
                  <label
                    for="email"
                    class="bold-right"
                    v-if="!waiveEnrollmentFee || intervalMultiplier === 1"
                    >${{ (total + fees) | toMonetary }}</label
                  >
                  <label for="email" class="bold-right" v-else
                    >${{ total | toMonetary }}</label
                  >
                </div>
              </div>

              <div v-if="patients.length === 0" class="empty-cart-div">
                <h4 class="empty-cart">Your Cart Is Empty</h4>
              </div>
            </form>
            <div class="form-success w-form-done">
              <div>Thank you! Your submission has been received!</div>
            </div>
          </div>
          <!-- shopping cart -->

          <div class="full-width w-form hidez">
            <div class="form-success w-form-done">
              <div>Thank you! Your submission has been received!</div>
            </div>
            <div
              class="form-error w-form-fail"
              style="
                 {
                  display: none;
                }
              "
            >
              <div>Oops! Something went wrong while submitting the form.</div>
            </div>
          </div>
          <h3 class="price">
            Grand Total
            <span class="text-span" v-if="intervalMultiplier === 1"
              >${{ (total + fees) | toMonetary }}</span
            >
            <span class="text-span" v-else>${{ total | toMonetary }}</span>
          </h3>
          <a
            v-show="patients.length > 0"
            href="#"
            class="button shopping-cart-bottom w-inline-block"
            @click="checkout"
          >
            <div>Checkout</div>
          </a>
        </div>
      </div>
    </div>
    <edit-table
      v-if="isEditing"
      :current-step="currentStep"
      :current-patient="currentPatient"
    />
    <personal-info
      v-if="currentStep === 1"
      :is-editing="isEditing"
      :current-patient="$v.currentPatient"
      :patients="patients"
    />
    <base-plan
      v-else-if="currentStep === 2"
      :senior-discount="qualifiedSeniorDiscount"
      :multi-patient-discount="qualifiedMultiPatientDiscount"
      :child-plans="childPlans"
      :traditional-plans="traditionalPlans"
      :traditional-annual-plans="traditionalAnnualPlans"
      :traditional-semi-annual-plans="traditionalSemiAnnualPlans"
      :perio-plans="perioPlans"
      :traditional="traditional"
      :current-patient="currentPatient"
      :is-editing="isEditing"
      :company="company"
    />
    <plan-addons
      v-else-if="currentStep === 3"
      :addons="addons"
      :current-patient="currentPatient"
      :company="company"
    />
    <plan-selections
      v-else-if="currentStep === 4"
      :patients="patients"
      @editSelection="editPatient"
      @addAnotherPatient="addAnother"
      @deletePatient="deletePatient"
    />
    <signup-information
      v-else-if="currentStep === 5"
      ref="cardInformation"
      :card-details="cardDetails"
      :total="total"
      :enrollment-fee="fees"
      :patients="patients"
      :client-secret="clientSecret"
      :stripe-account="stripeAccount"
      :account-owner="$v.accountOwner"
      :company="company"
      @confirmingCard="confirmingCard"
      @complete="confirmed"
      @failure="failedCard"
      @couponApplied="couponApplied"
    />
    <signup-success
      v-else-if="currentStep === 6"
      :account-owner="accountOwner"
      :company="company"
    />
    <signup-authentication-needed
      v-else-if="currentStep === 7"
      :account-owner="accountOwner"
      :company="company"
    />
    <div
      data-collapse="medium"
      data-animation="default"
      data-duration="400"
      data-w-id="39566f1c-22aa-ee0a-7be2-f1466e57a64f"
      role="banner"
      class="footer-bar w-nav"
    >
      <div class="wrapper nav-bar-wrapper">
        <div class="footer-columns">
          <a
            v-if="showPreviousButton"
            href="#"
            aria-current="page"
            class="button bigger w-inline-block w-clearfix w--current"
            @click="prev"
          >
            <img
              src="signUp/images/left-white.svg"
              alt=""
              class="button-icon bigger"
            />
            <div v-if="currentStep === 5" class="text-left bigger">
              PREVIOUS
            </div>
            <div v-else class="text-left bigger">BACK</div>
          </a>
          <a
            v-if="currentStep !== 6 || currentStep !== 7"
            id="w-node-f1466e57a656-9ede2a5a"
            href="#"
            class="button submit bigger w-inline-block w-clearfix"
            :class="[!canSubmit && currentStep === 5 ? 'disabled': '']"
            @click="next"
          >
            <div v-if="currentStep === 4" class="text-left bigger">
              Checkout
            </div>
            <div v-else-if="currentStep === 5" class="text-left bigger">
              SUBMIT
            </div>
            <div v-else class="text-left bigger">NEXT</div>
            <img
              src="signUp/images/right-white_1.svg"
              alt=""
              class="button-icon bigger"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Rest from "../rest/SignupPortalRest";
import AccountRest from "../rest/AccountRest";
import SubscriptionRest from "../rest/SubscriptionRest";
import PaymentRest from "../rest/PaymentRest";
import PersonalInfo from "../components/signup/Signup1";
import BasePlan from "../components/signup/Signup2";
import Addons from "../components/signup/Signup3";
import Selections from "../components/signup/Signup4";
import EditInfoTable from "../components/signup/SignupInfoTable";
import Summary from "../components/signup/SignupSummary";
import Success from "../components/signup/SignupSuccess";
import SignupAuthenticationNeeded from "../components/signup/SignupAuthenticationNeeded";
import Util from "../helpers/Util";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";
import moment from "moment";
import _ from "lodash";

const isDateValid = (value) => moment(value, "MM/DD/YYYY", true).isValid();

export default {
  name: "SignupPortal",
  directives: {
    hideEvent: {
      bind: function (el, binding, vnode) {
        this.event = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", this.event);
      },
      unbind: function (el) {
        document.body.removeEventListener("click", this.event);
      },
    },
  },
  filters: {
    toMonetary: function (value) {
      return Util.ConvertRealToMonetary(value);
    },
  },
  components: {
    "personal-info": PersonalInfo,
    "base-plan": BasePlan,
    "plan-addons": Addons,
    "plan-selections": Selections,
    "edit-table": EditInfoTable,
    "signup-information": Summary,
    "signup-success": Success,
    "signup-authentication-needed": SignupAuthenticationNeeded,
  },
  data() {
    return {
      company: null,
      patients: [],
      qualifiedDiscounts: [],
      plans: [],
      addons: [],
      discounts: [],
      qualifiedSeniorDiscount: null,
      qualifiedChildDiscount: null,
      qualifiedMultiPatientDiscount: null,
      traditional: true,
      currentPatient: {
        id: 0,
        first_name: "",
        last_name: "",
        birth_date: "",
        age: 0,
        accountHolder: false,
        discounts: [],
        addons: [],
      },
      accountOwner: {
        id: 0,
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        terms: false,
      },
      cardDetails: {
        number: false,
        expiry: false,
        cvc: false,
      },
      isEditing: false,
      currentStep: 1,
      clientSecret: null,
      stripeAccount: null,
      paymentMethod: null,
      loading: false,
      isCartOpen: false,
      isLegacy: true,
      intent: {},
      couponObj: null,
      canSubmit: false,
    };
  },
  validations: {
    currentPatient: {
      first_name: {
        required,
        minLength: minLength(2),
      },
      last_name: { required, minLength: minLength(2) },
      birth_date: {
        required,
        isDateValid(value) {
          if (value === undefined) {
            return true;
          } else {
            return isDateValid(value);
          }
        },
        minValue(value) {
          if (value === undefined) {
            return true;
          } else {
            if (moment(value).isValid()) {
              const actual = moment(value, "MM/DD/YYYY");
              const min = moment("01/01/1920");
              return actual >= min;
            } else {
              return true;
            }
          }
        },
        maxValue(value) {
          if (value === undefined) {
            return true;
          } else {
            if (moment(value).isValid()) {
              return moment(value, "MM/DD/YYYY") <= moment();
            } else {
              return true;
            }
          }
        },
      },
    },
    accountOwner: {
      first_name: {
        required,
        minLength: minLength(2),
      },
      last_name: { required, minLength: minLength(2) },
      email: {
        email,
        required,
      },
      phone: {
        required,
      },
      terms: {
        sameAs: sameAs(() => true),
      },
    },
  },
  computed: {
    intervalMultiplier() {
      if (this.patients[0]) {
        const interval = this.patients[0].plan.interval;
        if (interval === "year") {
          return 12;
        } else if (interval === "semi-annually") {
          return 6;
        }
      }

      return 1;
    },
    waiveEnrollmentFee() {
      if (this.company) {
        return this.company.company.waive_enrollment_fee_on_annual_payments;
      }

      return false;
    },
    childPlans() {
      var plans = [];
      _.forEach(this.plans, function (plan) {
        var data = _.find(plan.benefits, function (benefit) {
          return benefit.ada_code && benefit.ada_code.indexOf("D1120") !== -1;
        });
        if (data) {
          plan.frequency = data.pivot.frequency;
          plan.rewards = data.pivot.rewards;
          plan.selected = false;
          plan.interval = "month";
          plans.push(plan);
        }
      });
      return plans;
    },
    traditionalPlans() {
      var plans = [];
      _.forEach(this.plans, function (plan) {
        var data = _.find(plan.benefits, function (benefit) {
          return benefit.ada_code && benefit.ada_code.indexOf("D1110") !== -1;
        });
        console.log(data);
        if (data) {
          plan.frequency = data.pivot.frequency;
          console.log("pivoting plan frequency", data.pivot.frequency);
          plan.rewards = data.pivot.rewards;
          plan.selected = false;
          plan.interval = "month";
          plans.push(plan);
        }
      });
      console.log("tranditional plans:", plans);
      return plans;
    },
    traditionalAnnualPlans() {
      var plans = [];
      _.forEach(this.plans, function (plan) {
        const annualPlan = { ...plan };
        if (annualPlan.annual_base_price) {
          var data = _.find(annualPlan.benefits, function (benefit) {
            return benefit.ada_code && benefit.ada_code.indexOf("D1110") !== -1;
          });
          console.log(data);
          if (data) {
            annualPlan.frequency = data.pivot.frequency;
            annualPlan.rewards = data.pivot.rewards;
            annualPlan.selected = false;
            annualPlan.interval = "year";
            plans.push(annualPlan);
          }
        }
      });
      return plans;
    },
    traditionalSemiAnnualPlans() {
      var plans = [];
      _.forEach(this.plans, function (plan) {
        const semiAnnualPlan = { ...plan };
        if (semiAnnualPlan.semiannual_base_price) {
          var data = _.find(semiAnnualPlan.benefits, function (benefit) {
            return benefit.ada_code && benefit.ada_code.indexOf("D1110") !== -1;
          });
          console.log(data);
          if (data) {
            semiAnnualPlan.frequency = data.pivot.frequency;
            semiAnnualPlan.rewards = data.pivot.rewards;
            semiAnnualPlan.selected = false;
            semiAnnualPlan.interval = "semi-annually";
            plans.push(semiAnnualPlan);
          }
        }
      });
      return plans;
    },
    perioPlans() {
      var plans = [];
      _.forEach(this.plans, function (plan) {
        if (plan.is_perio) {
          var data = _.find(plan.benefits, function (benefit) {
            return benefit.ada_code && benefit.ada_code.indexOf("D4910") !== -1;
          });
          console.log("perio plan data:");
          console.log(data);
          if (data) {
            plan.frequency = data.pivot.frequency;
            plan.rewards = data.pivot.rewards;
            plan.selected = false;
            plan.interval = "month";
            plans.push(plan);
          }
        }
      });
      return plans;
    },
    seniorDiscount() {
      var data = _.find(this.discounts, function (discount) {
        return discount.senior == 1;
      });
      return data;
    },
    multiPatientDiscount() {
      var data = _.find(this.discounts, function (discount) {
        return discount.multiple_patient == 1;
      });
      return data;
    },
    childDiscount() {
      var data = _.find(this.discounts, function (discount) {
        return discount.child == 1;
      });
      return data;
    },
    selectedAddons() {
      const patientAddons = _.filter(this.addons, function (addon) {
        return addon.selected;
      });
      return patientAddons;
    },
    practiceFee() {
      const enrolled = _.filter(this.patients, function (p) {
        return p.plan;
      });

      return this.company.practice_enrollment_fee * enrolled.length;
    },
    fees() {
      if (this.company) {
        const enrolled = _.filter(this.patients, function (p) {
          return p.plan;
        });
        return (
          (this.company.enrollment_fee + this.company.practice_enrollment_fee) *
          enrolled.length
        );
      }

      return 0;
    },
    enrollmentFee() {
      const enrolled = _.filter(this.patients, function (p) {
        return p.plan;
      });
      return this.company.enrollment_fee * enrolled.length;
    },
    total() {
      const totalPlan = this.patients.reduce((sum, patient) => {
        if (patient.plan) {
          if (
            patient.plan.interval === "year" &&
            patient.plan.annual_base_price
          ) {
            return sum + patient.plan.annual_base_price;
          } else if (
            patient.plan.interval === "semi-annually" &&
            patient.plan.semiannual_base_price
          ) {
            return sum + patient.plan.semiannual_base_price;
          } else {
            if (patient.plan.interval === "semi-annually") {
              return sum + patient.plan.base_price * 6;
            } else if (patient.plan.interval === "year") {
              return sum + patient.plan.base_price * 12;
            }
            return sum + patient.plan.base_price;
          }
        } else {
          return sum + 0;
        }
      }, 0);
      const totalAddons = this.patients.reduce((sum, patient) => {
        if (patient.plan) {
          const totalAddons = patient.addons.reduce((sum, addon) => {
            if (patient.plan.interval === "year" && addon.annual_base_price) {
              return sum + addon.annual_base_price;
            } else if (
              patient.plan.interval === "semi-annually" &&
              addon.semiannual_base_price
            ) {
              return sum + addon.semiannual_base_price;
            } else {
              if (patient.plan.interval === "year") {
                return sum + addon.base_price * 12;
              } else if (patient.plan.interval === "semi-annually") {
                return sum + addon.base_price * 6;
              }
              return sum + addon.base_price;
            }
          }, 0);
          return sum + totalAddons;
        } else {
          return sum + 0;
        }
      }, 0);
      const totalDiscount = this.patients.reduce((sum, patient) => {
        if (patient.plan) {
          const totalDiscounts = patient.discounts.reduce((sum, disocunt) => {
            return sum + disocunt.appropriation_amount * this.intervalMultiplier;
          }, 0);
          return sum + totalDiscounts;
        } else {
          return sum + 0;
        }
      }, 0);
      return totalPlan + totalAddons - totalDiscount;
    },
    cardVerified: function () {
      if (
        this.cardDetails.number === true &&
        this.cardDetails.cvc === true &&
        this.cardDetails.expiry === true
      ) {
        return true;
      } else {
        return false;
      }
    },
    showPreviousButton() {
      if (this.currentStep === 4 || this.currentStep === 6) {
        return false;
      } else if (this.currentStep === 1) {
        if (this.patients.length >= 1 && !this.isEditing) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
  },
  mounted() {
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
    this.getCompany();
    this.getPlans();
    this.getPackages();
    this.getDiscounts();
    const patients = JSON.parse(this.$localStorage.get("patients"));
    const currentPatient = JSON.parse(this.$localStorage.get("currentPatient"));

    if (currentPatient) {
      this.currentPatient = currentPatient;
    }
    if (patients) {
      this.patients = patients;
      this.currentStep = 4;
    }
  },
  methods: {
    async getCompany() {
      const { data } = await Rest.FetchCompany();
      this.company = data;
      this.isLegacy = this.company.company.use_stripe_for_subscription === 0;
      console.log("Trying to get company...", this.company);
    },
    async getPlans() {
      const { data } = await Rest.FetchPlans();
      console.log(`Plans Data Fetch: ${data}`);
      this.plans = data;
    },
    async getPackages() {
      const { data } = await Rest.FetchPackages();
      _.forEach(data, function (addon) {
        addon.selected = false;
      });
      this.addons = data;
      if (this.currentPatient.id !== 0) {
        this.editPatient(this.currentPatient);
      }
    },
    async getDiscounts() {
      const { data } = await Rest.FetchDiscounts();
      this.discounts = data;
    },
    editPatient(patient) {
      this.isEditing = true;
      this.currentPatient = patient;
      this.currentStep = 1;
      _.forEach(this.addons, (addon) => {
        const selected = _.find(this.currentPatient.addons, function (a) {
          return a.id === addon.id;
        });
        if (selected) {
          addon.selected = true;
        } else {
          addon.selected = false;
        }
      });
      this.qualifiedSeniorDiscount = null;
      this.qualifiedMultiPatientDiscount = null;
      this.qualifiedChildDiscount = null;
      this.$localStorage.set(
        "currentPatient",
        JSON.stringify(this.currentPatient)
      );
    },
    addAnother() {
      this.currentStep = 1;
      this.resetCurrentPatient();
      this.$v.currentPatient.$reset();
      this.qualifiedSeniorDiscount = null;
      this.qualifiedMultiPatientDiscount = null;
      this.qualifiedChildDiscount = null;
      _.map(this.addons, function (a) {
        a.selected = false;
        return a;
      });
    },
    deletePatient(patient) {
      this.patients.splice(this.patients.indexOf(patient), 1);

      if (this.patients.length === 0) {
        this.$localStorage.remove("patients");
        this.addAnother();
      } else {
        const firstPatient = _.minBy(this.patients, function (p) {
          return p.id;
        });
        this.setPatientDiscount(firstPatient);
        this.$localStorage.set("patients", JSON.stringify(this.patients));
      }
    },
    next() {
      // We are adding/editing patient
      if (this.currentStep === 1) {
        this.$v.$touch();
        if (
          this.$v.currentPatient.$anyDirty &&
          !this.$v.currentPatient.$invalid &&
          !this.isEditing
        ) {
          const birthDate = moment(this.currentPatient.birth_date);
          const currentDate = moment();
          const age = currentDate.diff(birthDate, 'years');
          this.currentPatient.age = age;

          this.setDiscountAndPlan(age);
          this.$localStorage.set(
            "currentPatient",
            JSON.stringify(this.currentPatient)
          );
          this.currentStep++;
        } else {
          if (!this.$v.currentPatient.$anyDirty && this.isEditing) {
            const birthDate = moment(this.currentPatient.birth_date);
            const currentDate = moment();
            const age = currentDate.diff(birthDate, 'years');
            this.setDiscountAndPlan(age);
            this.currentStep++;
          } else {
            if (
              this.$v.currentPatient.$anyDirty &&
              !this.$v.currentPatient.$invalid
            ) {
              const birthDate = moment(this.currentPatient.birth_date);
              const currentDate = moment();
              const age = currentDate.diff(birthDate, 'years');
              this.setDiscountAndPlan(age);
              this.updatePatient(this.currentPatient);
              this.currentStep++;
            } else {
              this.$v.currentPatient.$touch();
            }
          }
        }
      } else if (this.currentStep === 2) {
        if (this.currentPatient.plan) {
          this.setPatientDiscount(this.currentPatient);
          if (!this.isEditing && this.currentPatient.id === 0) {
            if (this.patients.length >= 1) {
              this.currentPatient.id = _.last(this.patients).id + 1;
            } else {
              this.currentPatient.id = 1;
            }
            this.$localStorage.set(
              "currentPatient",
              JSON.stringify(this.currentPatient)
            );
            this.$localStorage.set("patients", JSON.stringify(this.patients));
            this.patients.push(this.currentPatient);
          } else {
            this.updatePatient(this.currentPatient);
          }

          this.currentStep++;
        }
      } else if (this.currentStep === 3) {
        this.currentPatient.addons = this.selectedAddons;
        this.updatePatient(this.currentPatient);
        this.resetCurrentPatient();
        this.$v.currentPatient.$reset();
        this.$v.accountOwner.$reset();
        if (this.isEditing) {
          this.isEditing = false;
        }
        this.$localStorage.remove("currentPatient");
        this.patients = JSON.parse(this.$localStorage.get("patients"));
        this.currentStep++;
      } else if (this.currentStep === 4) {
        // payment breakdown
        this.createIntent();
      } else if (this.currentStep === 5) {
        // submit
        if (
          this.$v.accountOwner.$anyDirty &&
          !this.$v.accountOwner.$invalid &&
          this.cardVerified &&
          this.paymentMethod
        ) {
          this.loading = true;
          const validatedOwner = this.accountOwner;
          const ownerInformation = _.find(this.patients, function (patient) {
            return (
              patient.first_name.toLowerCase().trim() ===
                validatedOwner.first_name.toLowerCase().trim() &&
              patient.last_name.toLowerCase().trim() ===
                validatedOwner.last_name.toLowerCase().trim()
            );
          });

          if (ownerInformation) {
            ownerInformation.email = validatedOwner.email;
            ownerInformation.phone = validatedOwner.phone;
            ownerInformation.accountHolder = true;

            this.updatePatient(ownerInformation);
          } else {
            this.accountOwner.id = _.last(this.patients).id + 1;
            this.accountOwner.accountHolder = true;
            this.accountOwner.birth_date = null;
            this.patients.push(this.accountOwner);
          }

          // Clean up patient names
          this.patients.forEach((patient) => {
            patient["first_name"] = patient["first_name"].trim();
            patient["last_name"] = patient["last_name"].trim();
          });

          const payload = {
            patients: this.patients,
          };
          if (this.isLegacy) {
            Rest.StoreAccount(payload)
              .then((result) => {
                console.log(result.data);
                this.account = result.data;

                _.forEach(this.patients, function (patient) {
                  const member = _.find(result.data.members, function (m) {
                    return (
                      patient.first_name.toLowerCase() ===
                        m.first_name.toLowerCase() &&
                      patient.last_name.toLowerCase() ===
                        m.last_name.toLowerCase()
                    );
                  });

                  if (member) {
                    patient.id = member.id;
                  }

                  return patient;
                });

                const payload = {
                  paymentMethod: this.paymentMethod,
                  totalCharge: this.total,
                  enrollmentFee: this.fees,
                  accountId: this.account.id,
                  patients: this.patients,
                };

                Rest.StoreSubscription(payload)
                  .then((result) => {
                    this.$localStorage.remove("patients");
                    this.loading = false;
                    this.currentStep++;
                  })
                  .catch((err) => {
                    this.loading = false;
                    console.log(err);
                  });
              })
              .catch((err) => {
                this.loading = false;
                console.log(err);
              });
          } else {
            payload["from_signup"] = true;
            console.log("attaching company:", this.company);
            payload["company_pk"] = this.company.company.id;
            let interval = "month";
            interval = this.patients[0].plan.interval;

            AccountRest.StoreAccountV2(payload)
              .then((result) => {
                console.log(result.data);
                this.account = result.data;

                _.forEach(this.patients, function (patient) {
                  const member = _.find(result.data.members, function (m) {
                    return (
                      patient.first_name.toLowerCase() ===
                        m.first_name.toLowerCase() &&
                      patient.last_name.toLowerCase() ===
                        m.last_name.toLowerCase()
                    );
                  });

                  if (member) {
                    patient.id = member.id;
                    if (patient.plan) {
                      patient.plan.interval = interval;
                    }
                  }

                  return patient;
                });

                const payload = {
                  paymentMethod: this.paymentMethod,
                  totalCharge: this.total,
                  enrollmentFee: this.enrollmentFee,
                  practiceFee: this.practiceFee,
                  members: result.data.members,
                  subscription: {
                    members: result.data.members,
                    interval: interval,
                    enrollmentFee: this.enrollmentFee,
                    practiceFee: this.practiceFee,
                    coupon: this.couponObj
                  },
                  intent: this.intent,
                  created_account: result.data.created_account,
                  created_account_holder: result.data.created_account_holder,
                  from_signup: true,
                };

                SubscriptionRest.StoreSubscriptionV2(0, payload)
                  .then((result) => {
                    this.$localStorage.remove("patients");
                    this.loading = false;
                    console.log(result, result.data);
                    if (result.data.code === 'stripe_authentication_required') {
                      this.currentStep = 7;
                    } else {
                      this.currentStep++;
                    }
                  })
                  .catch((err) => {
                    this.loading = false;
                    console.log(err);
                  });
              })
              .catch((err) => {
                this.loading = false;
                console.log(err);
              });
          }
        } else {
          this.$v.accountOwner.$touch();
        }
      }
    },
    createIntent() {
      this.loading = true;

      if (this.isLegacy) {
        Rest.CreateIntent()
          .then((response) => {
            this.clientSecret = response.data.intent.client_secret;
            this.stripeAccount = response.data.stripe_id;
            this.intent = response.data;
            this.currentStep++;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
          });
      } else {
        PaymentRest.CreateIntentV2({
          stripe_connected_acct_id:
            this.company.company.stripe_connected_acct_id,
          from_signup: true,
        })
          .then((response) => {
            this.clientSecret = response.data.setupIntent.client_secret;
            this.stripeAccount = this.company.company.stripe_connected_acct_id;
            this.intent = response.data.setupIntent;
            this.currentStep++;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
          });
      }
    },
    confirmingCard() {
      this.loading = true;
    },
    confirmed(paymentMethod) {
      this.canSubmit = true;
      this.paymentMethod = paymentMethod;
      this.loading = false;
    },
    failedCard() {
      console.log('trigger failure...');
      this.canSubmit = false;
      this.loading = false;
    },
    couponApplied(obj) {
      this.couponObj = obj;
    },
    prev() {
      if (this.currentStep === 1) {
        this.currentStep = 4;
        this.isEditing = false;
        this.resetCurrentPatient();
        this.$localStorage.remove("currentPatient");
      } else {
        this.currentStep--;
      }
    },
    updatePatient(patient) {
      const patientIndex = this.patients.findIndex((p) => p.id === patient.id);

      this.patients.splice(patientIndex, 1, patient);
      this.$localStorage.set("patients", JSON.stringify(this.patients));
    },
    resetCurrentPatient() {
      this.currentPatient = {
        id: 0,
        first_name: "",
        last_name: "",
        birth_date: "",
        age: 0,
        accountHolder: false,
        discounts: [],
        addons: [],
      };
    },
    setDiscountAndPlan(age) {
      this.currentPatient.discounts = [];
      this.qualifiedSeniorDiscount = null;
      this.qualifiedChildDiscount = null;
      this.qualifiedMultiPatientDiscount = null;

      if (age <= parseInt(this.company.settings.child_max_age)) {
        this.traditional = false; // display child plans
        if (this.childDiscount) {
          this.qualifiedChildDiscount = this.childDiscount;
        }
      } else if (age >= parseInt(this.company.settings.senior_min_age)) {
        if (this.seniorDiscount) {
          this.qualifiedSeniorDiscount = this.seniorDiscount;
        }
        this.traditional = true; // display traditionl and perio plans
      } else {
        this.traditional = true; // display traditionl and perio plans
      }

      // Activate multi patient discount
      if (this.patients.length >= 1) {
        const firstPatient = _.minBy(this.patients, function (p) {
          return p.id;
        });
        if (
          this.multiPatientDiscount &&
          this.currentPatient.id !== firstPatient.id
        ) {
          this.qualifiedMultiPatientDiscount = this.multiPatientDiscount;
        }
      }
    },
    setPatientDiscount(patient) {
      const birthDate = moment(patient.birth_date);
      const currentDate = moment();
      const age = currentDate.diff(birthDate, 'years');
      patient.discounts = [];
      if (age <= parseInt(this.company.settings.child_max_age)) {
        if (this.childDiscount) {
          patient.discounts.push(this.childDiscount);
        }
      } else if (age >= parseInt(this.company.settings.senior_min_age)) {
        if (this.seniorDiscount) {
          patient.discounts.push(this.seniorDiscount);
        }
      }
      // Activate multi patient discount
      if (this.patients.length >= 1) {
        const firstPatient = _.minBy(this.patients, function (p) {
          return p.id;
        });
        if (this.multiPatientDiscount && patient.id !== firstPatient.id) {
          patient.discounts.push(this.multiPatientDiscount);
        }
      }
      console.log(patient);
    },
    checkout() {
      this.resetCurrentPatient();
      this.$v.currentPatient.$reset();
      this.$v.accountOwner.$reset();
      this.isEditing = false;
      this.currentStep = 4;
      this.createIntent();
    },
    showCart() {
      if (this.patients.length > 0) {
        this.isCartOpen = !this.isCartOpen;
      } else {
        this.isCartOpen = false;
      }
    },
    hideCart() {
      this.isCartOpen = false;
    },
  },
};
</script>
<style scoped>
.preload {
  display: none;
  position: fixed;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.loader {
  border: 16px solid #e4e4e4;
  border-radius: 50%;
  border-top: 16px solid #4b9fe1;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.display-flex {
  display: flex;
}

.__PrivateStripeElement {
  top: 8px;
}

.button.submit.disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.button.submit {
  background-color: #4b9fe1;
  cursor: pointer;
}
</style>
